<!--
 * @Description: 打款总金额
 * @Date: 2020-12-12 16:02:25
-->
<template>
  <div>
    <div style="color: red">
      {{ formulaText }}
    </div>
    <table-render
      v-if="config"
      ref="tableRender"
      :config="config"
      height="35vh"
      width="80vw"
      @handleSearch="handleSearch"
    />
    <el-table
      v-else
      height="35vh"
      width="80vw"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column prop="date" label="日期" width="180"></el-table-column>
      <el-table-column prop="name" label="姓名" width="180"></el-table-column>
      <el-table-column prop="address" label="地址"></el-table-column>
    </el-table>
    <el-form :inline="true">
      <!-- 商务服务费没有该值 -->
      <el-form-item
        style="margin-bottom:0"
        label="支付通道："
        v-if="payPassagewayCode"
      >
        <span>{{ bankText }}</span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { csoCustomerOrder } from '@/api/ajax';
import tableRender from '@/components/tableRender';
import main from './config';
import { payBankFormatter } from '@/common/fields/bank';

export default {
  name: 'OrderServiceFee',
  props: {
    // 订单ID或者ids
    orderId: {
      type: Number,
      default: 0,
      required: true
    },
    // 1未支付-全部未支付 2未支付-部分支付 3已支付 4失效
    type: {
      type: Number,
      default: 0,
      required: true
    },
    projectName: {
      type: String
    },
    userEnterpriseType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      tableData: [],
      config: null,
      getTotalPriceAjax: null, // 获取总价接口
      finishSumTaskPrice: '', //终端结算总金额合计
      totalPrice: '', //结算总价合计
      payPassagewayCode: ''
    };
  },
  computed: {
    // 公式文案，园区个体单独处理
    formulaText() {
      const configMetaText = this.config && this.config[0].meta;
      return configMetaText;
    },
    bankText() {
      return payBankFormatter(this.$data);
    }
  },
  components: { tableRender },
  methods: {
    async handleSearch(v) {
      if (!v.pageSize) {
        v.pageSize = 10;
      }
      if (!v.pageNo) {
        v.pageNo = 1;
      }
      let { pdata } = await this.getTotalPriceAjax({
        ...v,
        orderId: this.orderId
        // csoCustomOrderId: this.orderId
      });
      Object.assign(this.$data, pdata);
    }
  },
  async created() {
    // let { pdata } = await csoCustomerOrder.oneOrderPlatformServiceOrder({
    //   orderId: this.orderId,
    //   pageSize: 1,
    //   pageNo: 1
    // });
    csoCustomerOrder
      .oneOrderBusServiceOrder({
        orderId: this.orderId,
        pageSize: 1,
        pageNo: 1
      })
      .then(result => {
        const { pdata } = result;
        // 此处的businessType与项目的不一致
        let type =
          (pdata.list[0].businessType || 1) +
          '-' +
          (pdata.list[0].patternType || 1);
        if (pdata.list[0].taxType == 2 || pdata.list[0].taxType == 3) {
          type = '11-6';
        }
        if (this.userEnterpriseType === 3) {
          type = 'individualPark';
        }

        const part = main(type);
        part.childMenu[0].defaultQuery = {
          orderId: this.orderId
          // csoCustomOrderId: this.orderId
        };
        this.getTotalPriceAjax = part.childMenu[0].individualAjax;
        this.config = [part];
      });
    // let type = (pdata.list[0].businessType || 1) + '-' + (pdata.list[0].patternType || 1);
  }
};
</script>
